<h3 mat-dialog-title>Box Interface</h3>
<mat-dialog-content>
    <ng-template #loadingGeneral>
        <mat-spinner class="center"></mat-spinner>
        <p class="center">Loading...</p>
    </ng-template>

    <ng-container *ngIf="errorMessage">
        {{errorMessage}}
    </ng-container>
    
    <ng-container *ngIf="!loading else loadingGeneral">
        <ul>
            <li *ngFor="let item of dataSource">
                <b>name</b>: {{item.iface_name}} - <b>type</b>: {{item.iface_type}}
        
        </ul>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
</mat-dialog-actions>

